/** ControlPlaneRoute — skin-aware switcher for /control-plane. */
import { useUISkin } from "@/data/UISkinContext";
import ControlPlane from "./ControlPlane";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function ControlPlaneRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Admin · IAM" title="Control Plane">
        <ControlPlane />
      </CockpitFrame>
    );
  }
  return <ControlPlane />;
}
